export function withQuery(path: string, qs: string): string {
  return qs.length > 0 ? `${path}?${qs}` : path;
}
